import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LoginService } from '../../pages/public/sign/services/login.service';

@Component({
  selector: 'app-keyboard',
  templateUrl: './keyboard.component.html',
  styleUrls: ['./keyboard.component.scss']
})
export class KeyboardComponent implements OnInit {

  key: string = ''
  positions: number[] = []
  numbers: number[] | undefined
  visible: boolean = false
  @Input() register: boolean = false

  constructor(
    private _service: LoginService,
  ) { }

  ngOnInit() {

  }

  send(num: number, i: number) {
    if (this.key.length < 6) {
      this.key = this.key + num.toString()
      this.positions.push(i)
    } 
  }

  del() {
    this.key = this.key.substring(0, this.key.length - 1)
    this.positions.splice(this.positions.length-1, 1)
  }

  show() {
    this._service.keyboard(this.register).subscribe((res:any) => {
      this.visible = true
      this.numbers = res.keyboard
    })
  }

  hide(){
    this.visible = false
  }

  close(){
    this.visible = false
    this.numbers = []
    this.positions = []
    this.key = ''
  }

}
